export const PriorityColors: any = {
  low: "#1DB547",
  medium: "#FDAE16",
  high: "#F26786",
  urgent: "#FC0A0A"
}

export const PriorityColorsArray = ["#5C5CEA", "#FDAE16", "#9CEAC2" , "#FEC8D8" ];

export const ALLOWED_EVENTS_IN_HISTORY = [
  "idea_updated",
  "idea_merged",
  "product_connected",
  "product_disconnected",
  "product_item_created",
  "synced_to_external",
  "idea_created",
  "sub_idea_created",
  "sub_idea_attached",
  "sub_idea_detached",
  "sub_idea_linked_to_parent",
  "sub_idea_unlinked_from_parent"
]

export const ColorsByPriority: any = {
  "deal-breaker": "#5C5CEA",
  "important": "#FDAE16",
  "nice-to-have": "#9CEAC2",
};


export enum DuplicationType {
  TITLE_AND_DESCRIPTION = 'title_and_description',
  DESCRIPTION = 'description',
  TITLE = 'title',
  SAME_MEANING = 'same_meaning'
}

export const DuplicationTypeLabels: Record<DuplicationType, string> = {
  [DuplicationType.TITLE_AND_DESCRIPTION]: 'Same title and description',
  [DuplicationType.DESCRIPTION]: 'Same description (different titles)',
  [DuplicationType.TITLE]: 'Same title (one lacking description)',
  [DuplicationType.SAME_MEANING]: 'Same meaning in different wording'
};
